import { ref, shallowRef } from 'vue'
import type { Component } from 'vue'

const isOpen = ref(false)
const dialogWidth = ref<string | number>('600px')
const dialogTitle = ref('')
const dialogComponent = shallowRef<Component | null>(null)
const dialogProps = ref<Record<string, unknown>>({})

let resolveDialog: ((value: unknown) => void) | null = null

export function useGlobalDialog() {
    const openDialog = <T>(
        component: Component,
        options?: {
            width?: string | number
            title?: string
            props?: Record<string, unknown>
        },
    ): Promise<T | null> => {
        dialogComponent.value = component
        dialogWidth.value = options?.width ?? '600px'
        dialogTitle.value = options?.title?.trim() ?? ''
        dialogProps.value = options?.props ?? {}
        isOpen.value = true

        return new Promise<T | null>((resolve) => {
            resolveDialog = resolve as (value: unknown) => void
        })
    }

    const closeDialog = () => {
        resolveDialog?.(null)
        resolveDialog = null
        isOpen.value = false
    }

    const finishDialog = <T>(result: T) => {
        resolveDialog?.(result)
        resolveDialog = null
        isOpen.value = false
    }

    return {
        isOpen,
        dialogWidth,
        dialogTitle,
        dialogComponent,
        dialogProps,
        openDialog,
        closeDialog,
        finishDialog,
    }
}
